module.exports = __webpack_public_path__ + "media/images/footer-twitter-icon-6a078b5cf6af4f0f32e32f1908b06e06.png";